import {
  Box,
  Button,
  Card,
  CardContent,
  Grid2,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import DisplayDetailsCard from "../../components/DisplayDetailsCard";

import {
  ALL,
  FOLLOWING,
  HOSTING,
  PLAYING,
  FILTER,
} from "../../values/constants";
import { useGetMyTournamentMutation } from "../../services/tournamentsAPI";
import {
  setSpicificTournamentData,
  setTournamentData,
} from "../../redux/slices/tournaments/tournamentSlice";
import { toast } from "react-toastify";
import { getTournamentProfilePic } from "../../uttils/common";

const TournamentHome = (props) => {
  const [tabSelected, setTabSelected] = useState(ALL);
  const { tournamentData } = useSelector((state) => state.tournaments);
  const dispatch = useDispatch();
  const _selectTab = (ele) => {
    setTabSelected(ele);
  };

  const [getMyTournament] = useGetMyTournamentMutation();

  const getAllTournaments = async () => {
    try {
      const res = await getMyTournament({
        hosting: tabSelected === HOSTING ? true : false,
        following: tabSelected === FOLLOWING ? true : false,
        playing: tabSelected === PLAYING ? true : false,
        // filter: {
        //   location: location,
        //   category: category,
        //   tournamentType: tournamentType,
        //   matchType: matchType,
        //   status: status,
        // },
      });
      const response = res?.data?.data;
      if (res?.data?.success) {
        dispatch(setTournamentData(response));
      } else {
        toast.error(response?.error?.data?.message);
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  const currentSelectedTab = useSelector(
    (state) => state.home.currentSelectedTab
  );

  const navigate = useNavigate();

  useEffect(() => {
    if (currentSelectedTab !== "Tournaments") {
      navigate(-1);
    }
  }, [currentSelectedTab, navigate]);

  useEffect(() => {
    getAllTournaments();
  }, [tabSelected]);

  const _onTournamentClick = (tournamentId) => {
    for (let tour of tournamentData) {
      if (tour._id === tournamentId) {
        const res = tour;
        // const organizerData = res?.organizerId;
        dispatch(setSpicificTournamentData(res));
        // dispatch(setOrganizerData(organizerData));
        navigate("/user/tournamentDashboard");
      } else {
        console.log("No");
      }
    }
  };

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
      }}
    >
      <Stack mt={8} ml={4} display={"flex"} flexDirection={"row"}>
        <Stack display={"flex"} flex={1}>
          <Typography variant="h6">Tournaments</Typography>
        </Stack>

        <Stack
          mr={4}
          sx={{
            display: {
              xs: "block",
              sm: "block",
              md: "none",
              lg: "none",
            },
          }}
        >
          <Button
            sx={{
              paddingY: "0.6rem",
              textTransform: "initial",
            }}
            className={tabSelected == FILTER ? "selectedTab" : "unSelectedTab"}
            onClick={() => _selectTab(FILTER)}
          >
            <Typography
              variant="subtitle1"
              sx={{
                fontSize: "1rem",
                color: tabSelected == FILTER ? "#fff" : "#000",
              }}
            >
              Filter
            </Typography>
          </Button>
        </Stack>
      </Stack>

      <Stack m={4} direction={"row"}>
        <Stack display="flex" flex={1}>
          <Stack
            flex={1}
            display="flex"
            direction={"row"}
            spacing={2}
            maxWidth={"30rem"}
          >
            <Button
              sx={{
                flex: 1,
                paddingY: "0.6rem",
                textTransform: "initial",
              }}
              className={tabSelected == ALL ? "selectedTab" : "unSelectedTab"}
              onClick={() => _selectTab(ALL)}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: "1rem",
                  color: tabSelected == ALL ? "#fff" : "#000",
                }}
              >
                All
              </Typography>
            </Button>
            <Button
              sx={{
                flex: 1,
                paddingY: "0.6rem",
                textTransform: "initial",
              }}
              className={
                tabSelected == HOSTING ? "selectedTab" : "unSelectedTab"
              }
              onClick={() => _selectTab(HOSTING)}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: "1rem",
                  color: tabSelected == HOSTING ? "#fff" : "#000",
                }}
              >
                Hosting
              </Typography>
            </Button>
            <Button
              sx={{
                flex: 1,
                paddingY: "0.6rem",
                textTransform: "initial",
              }}
              className={
                tabSelected == PLAYING ? "selectedTab" : "unSelectedTab"
              }
              onClick={() => _selectTab(PLAYING)}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: "1rem",
                  color: tabSelected == PLAYING ? "#fff" : "#000",
                }}
              >
                Playing
              </Typography>
            </Button>
            <Button
              sx={{
                flex: 1,
                paddingY: "0.6rem",
                textTransform: "initial",
              }}
              className={
                tabSelected == FOLLOWING ? "selectedTab" : "unSelectedTab"
              }
              onClick={() => _selectTab(FOLLOWING)}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: "1rem",
                  color: tabSelected == FOLLOWING ? "#fff" : "#000",
                }}
              >
                Following
              </Typography>
            </Button>
          </Stack>
        </Stack>
        <Stack
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
            },
          }}
        >
          <Button
            sx={{
              paddingY: "0.6rem",
              textTransform: "initial",
            }}
            className={tabSelected == FILTER ? "selectedTab" : "unSelectedTab"}
            onClick={() => _selectTab(FILTER)}
          >
            <Typography
              variant="subtitle1"
              sx={{
                fontSize: "1rem",
                color: tabSelected == FILTER ? "#fff" : "#000",
              }}
            >
              Filter
            </Typography>
          </Button>
        </Stack>
      </Stack>
      <Stack mx={2}>
        <Grid2 container size={12}>
          {tournamentData?.map((item) => (
            <Grid2 size={{ xs: 12, sm: 12, md: 4 }}>
              <DisplayDetailsCard
                heading={item?.name}
                subtitle={item?.groundId?.name}
                location={item?.city?.name}
                item={item}
                onClick={() => _onTournamentClick(item?._id)}
                imageLogo={getTournamentProfilePic(item?.logo)}
                enableShadow
              />
            </Grid2>
          ))}
        </Grid2>
      </Stack>

      {/* <Grid2 container>
        <Grid2 direction={"row"} size={{ xs: 12, sm: 12, md: 8 }}>
          <Grid2 sx={{ backgroundColor: "red" }}></Grid2>
        </Grid2>
      </Grid2> */}
    </Box>
  );
};

export default TournamentHome;
